<template>
  <InfuseTag :inline="true">
    <font-awesome-icon :icon="['fal', type === UserType.MACHINE ? 'robot' : 'user']" class="mr-2" />
    <span>{{ type === UserType.MACHINE ? t('iam.users.type.machine') : t('iam.users.type.person') }}</span>
  </InfuseTag>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { UserType } from '@infuse/iam/user/type';
import { InfuseTag } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  type: UserType;
}>();
</script>
